import React from "react";
import "./assets/customStyles/pfSansProTypography.css";
import "./assets/customStyles/symmetryIcons.css";
import "./styles.css";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider, initReactI18next } from "react-i18next";
import common_en from "./static/trans/en.json";
import common_gr from "./static/trans/gr.json";
import common_ru from "./static/trans/ru.json";
import { Provider } from "react-redux";
import store from "./store/createStore";
import indexRoutes from "./routes/main";
import { Route, Switch } from "react-router-dom";
import { createRoot } from "react-dom/client";
import i18n from "i18next";

const resources = {
	en: {
		common: common_en,
	},
	gr: {
		common: common_gr,
	},
	ru: {
		common: common_ru,
	},
};

i18n.use(initReactI18next).init({
	resources,
	fallbackLng: ["gr", "en", "ru"],
	lng: sessionStorage.getItem("language") || "gr",
});

window.__dev__ = process.env.NODE_ENV !== "production";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<main id="pageContent">
		<Provider store={store}>
			<I18nextProvider i18n={i18n}>
				<Router>
					<Switch>
						{indexRoutes.map((prop, key) => {
							return (
								<Route path={prop.path} key={key} component={prop.component} />
							);
						})}
					</Switch>
				</Router>
			</I18nextProvider>
		</Provider>
	</main>,
);
